import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Endereco } from 'src/app/models/endereco';

@Injectable({
  providedIn: 'root'
})
export class EnderecoService {

  static GOOGLE_API_KEY = 'AIzaSyBAjMKX3-uaF8jRUBJTGJpxXLWNnzxwey8';

  constructor(private httpClient: HttpClient) { }

  pesquisaCEP(data: Endereco | string, ignore = ['401', 'auth']) {
    let cep = ( data instanceof Endereco ) ? data.cep : data;
    const temPontuacao = /\D/g.test(cep);
    if(temPontuacao){
      cep = cep.replace(/\D/g,'');
    }
    return this.httpClient.get<Endereco>('https://viacep.com.br/ws/'+ cep + '/json/ ',
    {
      params: {
        ignore: ignore
      }
    }).pipe(map(r => {
      let endereco = new Endereco(r);
      if ( data instanceof Endereco ) {
        endereco.id = data.id || endereco.id;
        endereco.latitude = data.latitude || endereco.latitude;
        endereco.longitude = data.longitude || endereco.longitude;
        endereco.unidade = data.unidade || endereco.unidade;
      }
      return endereco;
    })).toPromise();
  }

  presquisaLatLgt(endereco: Endereco, ignore = ['loading', '401', 'auth', 'content-type']) {
    return this.httpClient.get<Endereco>('https://maps.googleapis.com/maps/api/geocode/json?key=' + EnderecoService.GOOGLE_API_KEY,
      {
        params: {
          address: endereco.strSearchMaps(),
          ignore: ignore
        }
      }).pipe(map(e => {
        if(e['status']=='OK') {
          endereco.latitude  = e['results'][0]['geometry']['location']['lat'];
          endereco.longitude = e['results'][0]['geometry']['location']['lng'];
        }
        return endereco;
      })).toPromise();
  }

}
